type MenuItemImageSource =
  | {
      image?: string | null
      image_url?: string
      photo?: string
      thumbnail?: string
      cover?: string
    }
  | null
  | undefined

export function resolveMenuItemImageUrl(item: MenuItemImageSource): string | null {
  if (item == null) return null

  const raw =
    [item.image, item.image_url, item.photo, item.thumbnail, item.cover].find(
      (value) => value != null && value !== ''
    ) ?? null

  if (raw == null || raw === '') return null
  if (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('data:')) {
    return raw
  }

  const baseUrl = useRuntimeConfig().public.apiBaseUrl
  if (baseUrl === '') return raw
  if (raw.startsWith('/')) return `${baseUrl}${raw}`
  return `${baseUrl}/${raw}`
}
